<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 18:52:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-20 14:00:21
-->
<template>
  <div class="index-introduction wh100">
    <div class="ui-index-title p-t-30">{{ $t('frontPage.introduction.title') }}</div>
    <div class="swiper index-introduction-banner" id="indexIntroduction">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in $t('frontPage.introduction.banner')" :key="item.id">
          <h3 class="slide-title" v-html="item.title"></h3>
          <div v-if="language == 'en'" class="flex">
            <div class="slide-des-box textj en">
              <a class="slide-more" v-if="item.id != 4" :href="language == 'en' ? '/en/about' : '/about'" target="_blank">More &gt;&gt;</a>
              <span class="slide-des" v-for="($item, index) in item.des" :key="index" v-html="$item"></span>
            </div>
          </div>
          <div class="textj" v-else><p class="slide-des" v-for="($item, index) in item.des" :key="index" v-html="$item"></p></div>
        </div>
      </div>
      <div class="swiper-pagination index-introduction-pagination"></div>
    </div>
    <div v-if="language == 'en'" class="index-introduction-related en">
      <div class="wh100">
        <div class="flex align_items_center">
          <div class="related-item flex_1 flex flex_col justify_content_center">
            <div class="related-item-num flex justify_content_center">
              <span>{{hospitals}}</span>
              <span>+</span>
            </div>
            <div v-html="$t('frontPage.introduction.related.hospitals')"></div>
          </div>
          <div class="related-item flex_1 flex flex_col justify_content_center">
            <div class="related-item-num flex justify_content_center">
              <span>{{province}}</span>
              <span>+</span>
            </div>
            <div v-html="$t('frontPage.introduction.related.province')"></div>
          </div>
        </div>
        <div class="flex align_items_center">
          <div class="related-item flex_1 flex flex_col justify_content_center">
            <div class="related-item-num flex justify_content_center">
              <span>{{second}}</span>
              <span>min</span>
            </div>
            <div v-html="$t('frontPage.introduction.related.second')"></div>
          </div>
          <div :class="['related-item flex flex_col justify_content_center', language == 'en' ? 'flex_1' : '']">
            <div class="related-item-num flex justify_content_center">
              <span>{{percentage}}</span>
              <span>%</span>
            </div>
            <div v-html="$t('frontPage.introduction.related.percentage')"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="index-introduction-related">
      <div class="wh100 flex align_items_center">
        <div class="related-item flex_1">
          <div class="related-item-num flex justify_content_center">
            <span>{{hospitals}}</span>
            <span>+</span>
          </div>
          <div v-html="$t('frontPage.introduction.related.hospitals')"></div>
        </div>
        <div class="related-item flex_1">
          <div class="related-item-num flex justify_content_center">
            <span>{{province}}</span>
            <span>+</span>
          </div>
          <div v-html="$t('frontPage.introduction.related.province')"></div>
        </div>
        <div class="related-item flex_1">
          <div class="related-item-num flex justify_content_center">
            <span>{{second}}</span>
            <span>min</span>
          </div>
          <div v-html="$t('frontPage.introduction.related.second')"></div>
        </div>
        <div class="related-item">
          <div class="related-item-num flex justify_content_center">
            <span>{{percentage}}</span>
            <span>%</span>
          </div>
          <div v-html="$t('frontPage.introduction.related.percentage')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    realIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      hospitals: 0,
      province: 0,
      second: 100,
      percentage: 0
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexIntroduction', {
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      observeParents: true,
      pagination: {
        el: '.index-introduction-pagination',
        bulletElement: 'li',
        clickable: true
      }
    })
    this.scrollNum()
  },
  methods: {
    scrollNum () {
      if (this.hospitals !== 300) {
        let timer = setInterval(() => {
          if (this.hospitals < 300) {
            this.hospitals += 10
          } else {
            this.hospitals = 300
            clearInterval(timer)
            timer = null
          }
        }, 100)
      }
      if (this.province !== 20) {
        let timer = setInterval(() => {
          if (this.province < 20) {
            this.province += 1
          } else {
            this.province = 20
            clearInterval(timer)
            timer = null
          }
        }, 100)
      }
      if (this.second !== 5) {
        let timer = setInterval(() => {
          if (Math.ceil(this.second) > 5) {
            this.second = Math.floor(Math.abs(this.second -= 2.5))
          } else {
            this.second = 5
            clearInterval(timer)
            timer = null
          }
        }, 100)
      }
      if (this.percentage !== 95) {
        let timer = setInterval(() => {
          if (this.percentage < 95) {
            this.percentage = Math.floor(Math.abs(this.percentage += 4.6))
          } else {
            this.percentage = 95
            clearInterval(timer)
            timer = null
          }
        }, 100)
      }
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.mySwiper = null
  }
}
</script>

<style lang="less" scoped>
/*订单总量滚动数字设置*/
 .m .box-item {
  position: relative;
  height: 100px;
  font-size: 54px;
  line-height: 41px;
  text-align: center;
  list-style: none;
  color: #2D7CFF;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
 }
 /* 默认逗号设置 */
 .mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 48px;
  position: relative;
  & > span {
   position: absolute;
   width: 100%;
   bottom: 0;
   writing-mode: vertical-rl;
   text-orientation: upright;
  }
 }
 /*滚动数字设置*/
 .m .number-item {
  width: 41px;
  height: 75px;
  background: #ccc;
  list-style: none;
  margin-right: 5px;
  background:rgba(250,250,250,1);
  border-radius:4px;
  border:1px solid rgba(221,221,221,1);
  & > span {
   position: relative;
   display: inline-block;
   margin-right: 10px;
   width: 100%;
   height: 100%;
   writing-mode: vertical-rl;
   text-orientation: upright;
   overflow: hidden;
   & > i {
    font-style: normal;
    position: absolute;
    top: 11px;
    left: 50%;
    transform: translate(-50%,0);
    transition: transform 1s ease-in-out;
    letter-spacing: 10px;
   }
  }
 }
 .m .number-item:last-child {
  margin-right: 0;
 }
</style>

<style lang="less" scoped>
.m .index-introduction {
  background-image: url(../../../../../assets/images/m/index/introduction.gif);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-color: #F3F3F3;
  padding-bottom: 38px;
  .index-introduction-banner {
    margin: 0;
    // height: 360px; /*no*/
    width: 90%;
    margin: 0 auto;
    padding-top: 62px;
    padding-bottom: 80px;
    position: relative;
    .swiper-wrapper {
    }
    .swiper-slide {
      height: 100%;
      // opacity: 0;
      color: #333333;
      font-size: 24px;
      visibility: hidden;
      &.swiper-slide-active {
        // opacity: 1;
        visibility: inherit;
      }
      .slide-title {
        font-size: 26px;
        font-weight: 600;
        padding-bottom: 30px;
        text-align: center;
        line-height: 38px;
      }
      .slide-des {
        text-indent: 2em;
        line-height: 34px;
        padding: 10px 0;
      }
      .slide-des-box {
        overflow: hidden;
        word-break: inherit;
        line-height: 1.5em;
        max-height: 9em;
        color: #000000;
        &::before{
          content: '';
          float: right;
          width: 0;
          height: 100%;
          margin-bottom: -1.5em;
        }
        .slide-more {
          color: #00A0E9;
          float: right;
          margin-top: -4px;
          clear: both;
          position: relative;
          padding-left: 1.5em;
          &::before{
            content: '...';
            position: absolute;
            left: 1.2em;
            color: rgba(0, 0, 0, 0.5);
            transform: translateX(-100%);
            // box-shadow: -6px 0px 10px 4px #fff;
            // background: rgba(255, 255, 255, .6);
          }
        }
      }
    }
    .swiper-pagination.index-introduction-pagination{
      height: 20px;
      bottom: 36px;
      /deep/ .swiper-pagination-bullet{
        margin: 0 17px;
      }
    }
  }
  .index-introduction-related {
    background: #ffffff;
    width: calc(100% - 30px);
    padding-right: 10px;
    margin-left: 30px;
    text-align: center;
    color: #333333;
    font-size: 20px;
    box-shadow: 0px 6px 10px 3px rgba(95,184,233,0.18);
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    &:not(.en) {
      height: 160px;
      font-size: 20px;
      .related-item {
        .related-item-num {
          font-size: 30px;
          font-weight: 600;
          padding-bottom: 10px;
        }
        &:last-child {
          min-width: 12em;
        }
      }
    }
    &.en {
      font-size: 24px;
      .related-item {
        height: 136px;
        .related-item-num {
          font-size: 30px;
          font-weight: 600;
          line-height: 42px;
        }
        &:last-child {
          min-width: 12em;
          line-height: 30px;
        }
      }
    }
  }
}
.m.en .index-introduction {
  .index-introduction-banner {
    // width: 100%;
    // padding: 5%;
    // padding-right: 2%;
    .swiper-pagination.index-introduction-pagination{
      bottom: 16px;
    }
  }
}
</style>
